import { makeStyles } from "@material-ui/core";
import React from "react";
import Card from './cardItems';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexDirection:'column',
        ...theme.grid.gridMdContent,
        width: "100%",
        // margin: "45px auto",
        maxWidth: '100%',
        // backgroundImage: `linear-gradient(to bottom, rgba(11, 23, 66, 0.7), rgba(11,23,66, 07)), url('/assets/images/newImages/bgKala.png');`,
        backgroundImage: `url('/assets/images/newImages/bgKala.jpg');`,
        // backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0,0,0, 0.7)), url('/assets/images/newImages/bgKala.png');`,
    },
    gridConent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        ...theme.grid.gridMdContent,
        width: "65%",
        width: 1140,
        width: 1200,
        minHeight: 400,
        margin: "0px auto",
        maxWidth: '95%',

        '@media (max-width:1001px)': {
            width: '400px',
            marginTop:50
        },
        '@media (max-width:500px)': {
            width: '100%',
        },
        '@media (max-width:445px)': {
            justifyContent: 'center',
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',

    },
    gridTitle: {
        position: 'relative',
        marginTop:100,
        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
    title: {
        fontSize: 28,
        color:'white'
    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridTitle']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                خدمات پویان در بورس کالا
                </h3>
            </div>
            <div className={classes['gridConent']}>
                {
                    dataService?.map((item, index) => {
                        return (
                            <Card data={item} key={index} />
                        )
                    })
                }
            </div>
        </div>
    );
}


let dataService = [
    {
        title: "خرید با مناسب‌ترین  ",
        desc: "قیمت از بورس کالا",
        icon: "/assets/icons/kala/serviceKala3.svg",
    },

    {
        title: "برگزاری",
        desc: "دوره‌های آموزشی",
        icon: "/assets/icons/kala/serviceKala4.svg",
    },

    {
        title: "گزارش معاملات و",
        desc: "تحلیل‌های تخصصی",
        icon: "/assets/icons/kala/serviceKala5.svg",
    },

    {
        title: "پذیرش و ",
        desc: "عرضه کالا",
        icon: "/assets/icons/kala/serviceKala2.svg",
    },

    {
        title: "مشاوره‌های تخصصی ",
        desc: "در بورس کالا",
        icon: "/assets/icons/kala/serviceKala1.svg",
    },



]